module.exports = __webpack_public_path__ + "static/media/manage_access.e4a304a7.svg";